import $ from "jquery";
import "bootstrap-slider";
import {urlQuestionnaire} from "../js/config";

function openForm(selector) {
    $('body').css('overflow-y', 'hidden');
    $('.loader').css('display', 'flex').fadeIn();
    $('.choice-poll').hide();

    const delay = t => new Promise(resolve => setTimeout(resolve, t));
    delay(1000).then(() => {
        $(selector).fadeIn(1000);

        if (selector === '.trial-form') {
            $("#ex1").slider({
                ticks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                ticks_labels: ['<br />1', '<br />2', '<br />3', '<br />4', '<br />5', '<br />6', '<br />7', '<br />8', '<br />9', '<br />10'],
            });
        }

        if (selector === '.trial-form-ar') {
            $("#ex2").slider({
                ticks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                ticks_labels: ['<br />1', '<br />2', '<br />3', '<br />4', '<br />5', '<br />6', '<br />7', '<br />8', '<br />9', '<br />10'],
            });
        }

        $('body').css('overflow-y', 'auto');
        $('.loader').css('display', 'none').fadeOut();
    });
}

function setMainFont(font) {
    const style = document.createElement("style");
    style.type = "text/css";
    style.appendChild(
        document.createTextNode("* { " + font + "}")
    );
    document.head.appendChild(style);

}

export default {
    init() {
        (function ($) {
            $.fn.loading = function (action, lang) {
                const self = $(this);

                let text = $(self).val();
                let newText = 'Sending';

                if (lang === 'Arabic') {
                    newText = 'إرسال';
                }

                if (action === 'start') {
                    if ($(self).attr("disabled") === "disabled") {
                        self.preventDefault();
                    }
                    $('.has-spinner').attr("disabled", "disabled");
                    $(self).attr('data-btn-text', $(self).val());
                    $(self).html(newText + '<span class="has-spinner__spinner"><img src="/wp-content/uploads/loader.gif" width="30" height="30"></span>');
                    $(self).addClass('has-spinner--active');
                }
                if (action === 'stop') {
                    $(self).html($(self).attr('data-btn-text'));
                    $(self).removeClass('has-spinner--active');
                    $('.has-spinner').removeAttr("disabled");
                }
            }
        })($);

        $('.text-field-container--for-radio').on('click', function (e) {
            $('.fields-poll__box--radio').addClass('fields-poll__name-box--unactive');
        });

        $('.fields-poll__field--left').on('click', function (e) {
            $('.fields-poll__box--radio').removeClass('fields-poll__name-box--unactive');
            $('.text-field-container__field--for-radio').val('');
        });

        let typeForm;
        let questionnaireLang;

        $('.trial').on('click', function () {
            openForm('.trial-form');
            typeForm = 'trial';
            questionnaireLang = 'English';
        });

        $('.trial-ar').on('click', function () {
            openForm('.trial-form-ar');
            setMainFont('font-family: Dubai, sans-serif !important');
            typeForm = 'trial';
            questionnaireLang = 'Arabic';
        });

        $('.membership').on('click', function () {
            openForm('.membership-form');
            typeForm = 'membership';
            questionnaireLang = 'English';
        });

        $('.membership-ar').on('click', function () {
            openForm('.membership-form-ar');
            setMainFont('font-family: Dubai, sans-serif !important');
            typeForm = 'membership';
            questionnaireLang = 'Arabic';
        });

        $('.form-poll').submit(function (e) {
            e.preventDefault();
            let form = $(this);
            let data = form.serialize();
            data += '&type=' + typeForm;
            data += '&lang=' + questionnaireLang;

            $.ajax({
                type: "POST",
                url: urlQuestionnaire,
                dataType: "json",
                data: data,
                beforeSend: function () {
                    $('.has-spinner').loading('start', questionnaireLang);
                },
                complete: function () {
                    $('.has-spinner').loading('stop');
                },
                success: function (msg) {
                    console.log('success');
                    window.location.href = '/thank-you-questionnaire/';
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.warn(xhr.responseText);
                    console.log(xhr, ajaxOptions, thrownError, arguments);
                },
            });
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};

